export enum Checkpoint {
  CLAIM_SUBMITTED = "CLAIM_SUBMITTED",
  DAMAGED_PARTS_SUBMITTED = "DAMAGED_PARTS_SUBMITTED",
  FLOW_COMPLETED = "FLOW_COMPLETED",
}
